import { render } from "./5_bodegas.vue?vue&type=template&id=f1065a1a&scoped=true"
import script from "./5_bodegas.vue?vue&type=script&lang=js"
export * from "./5_bodegas.vue?vue&type=script&lang=js"

import "./5_bodegas.vue?vue&type=style&index=0&id=f1065a1a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1065a1a"]])

export default __exports__